module.exports = __webpack_public_path__ + "static/praga-4-427a5cb0ecb52708181db8bdc55c845c.jpg";